<ng-container *ngIf="avatar.showFallback()">
  <div [class]="classes">
    <ng-content></ng-content>
  </div>
</ng-container>
